export const RESOURCE_ORDER = [
    'bones',
    'deadwood',
    'souls',
    'graveOre',
    'ectoplasm',
    'graveIron',
    'soulCrystal',
    'graveSeal',
    'spiritBinding'
]

export const RESOURCES = {
    bones: { label: 'Bones', shortLabel: 'BONES', color: '#e5ddca', material: 'bone' },
    deadwood: { label: 'Deadwood', shortLabel: 'WOOD', color: '#665047', material: 'deadwood' },
    souls: { label: 'Souls', shortLabel: 'SOULS', color: '#75ffb2', material: 'soul' },
    graveOre: { label: 'Grave ore', shortLabel: 'ORE', color: '#62666d', material: 'graveStone' },
    ectoplasm: { label: 'Ectoplasm', shortLabel: 'ECTO', color: '#4de89b', material: 'ectoplasm' },
    graveIron: { label: 'Grave iron', shortLabel: 'IRON', color: '#78888a', material: 'graveIron' },
    soulCrystal: { label: 'Soul crystal', shortLabel: 'CRYSTAL', color: '#8dffca', material: 'soulCrystal' },
    graveSeal: { label: 'Grave seal', shortLabel: 'SEAL', color: '#91a5a0', material: 'graveIron' },
    spiritBinding: { label: 'Spirit binding', shortLabel: 'BINDING', color: '#6cffb0', material: 'soul' }
}

export const TUNING = {
    backpackCapacity: 20,
    machineSlotCapacity: 10,
    outputCapacity: 10,
    gatherInterval: 0.6,
    workerGatherInterval: 2,
    transferInterval: 0.22,
    stationaryDelay: 0.22,
    gatherRange: 2.35,
    machineRange: 2.5,
    tileHalfSize: 1.55,
    playerSpeed: 4.2,
    workerSpeed: 2.35,
    porterSpeed: 2.8,
    walkRadius: 34,
    sourceRegrowSeconds: 45,
    fuelSeconds: { souls: 8, deadwood: 4 },
    porterCapacity: 4,
    cryptRaiseSeconds: 3,
    obeliskHealth: 800
}

const treePositions = [
    [1, 11], [4, 9], [-6, 10], [6, 12], [-11, 0],
    [-13, 15], [-8, 15], [-3, 15], [2, 15], [7, 15], [12, 15],
    [-14, 18], [-9, 18], [-4, 18], [1, 18], [6, 18], [11, 18],
    [-13, 21], [-8, 21], [-3, 21], [2, 21], [7, 21], [12, 21],
    [-11, 24], [-6, 24], [-1, 24], [4, 24], [9, 24], [14, 24],
    [-27.42, -7.96], [-22.81, -5.22], [-21.39, -10.14], [-15.98, 4.52],
    [-26.48, 10.1], [-21.31, 10.03], [-23.99, -8.43], [-16.52, 10.51],
    [-27.27, 7.08], [-24.19, 0.23], [-18.5, -11.05], [-18.2, -6.99],
    [-25.07, -5.15], [-26.1, -2.01], [-14.64, -3.28], [-18.28, -2.55],
    [-17.17, 0.71], [-20.56, 5.15], [-18.77, 8.7], [-15.42, -10.03],
    [-22.51, -2.21], [-16.75, 7.09], [-22.38, 1.54]
]

export const DEPOSITS = [
    { id: 'graveOrePatch', resource: 'graveOre', x: -11.394, y: 7.121, amount: 180, revealWave: 1 },
    { id: 'ectoplasmSeep', resource: 'ectoplasm', x: -11.394, y: -7.121, amount: 180, revealWave: 3 },
    { id: 'bonePile', resource: 'bones', x: 10.037, y: 8.603, amount: 160, revealWave: 0 },
    { id: 'soulFont', resource: 'souls', x: 10.255, y: -7.325, amount: 160, revealWave: 0 },
    ...treePositions.map(([x, y], index) => ({
        id: `deadTree${index + 1}`,
        resource: 'deadwood',
        x,
        y,
        amount: 8,
        tree: true,
        revealWave: 0
    }))
]

export const BUILDING_TYPES = {
    guardCrypt: { label: 'Bone Guard Crypt', kind: 'crypt', units: ['guard'] },
    graveForge: { label: 'Grave Forge', kind: 'processor', input: 'graveOre', output: 'graveIron', fuel: true, duration: 2 },
    sealAltar: { label: 'Seal Altar', kind: 'processor', input: 'graveIron', output: 'graveSeal', fuel: false, duration: 1.5 },
    soulCrucible: { label: 'Soul Crucible', kind: 'processor', input: 'ectoplasm', output: 'soulCrystal', fuel: true, duration: 2 },
    bindingCircle: { label: 'Binding Circle', kind: 'processor', input: 'soulCrystal', output: 'spiritBinding', fuel: false, duration: 1.5 },
    harvesterCrypt: { label: 'Harvester Crypt', kind: 'crypt', units: ['miner', 'woodcutter'] },
    porterCrypt: { label: 'Porter Crypt', kind: 'crypt', units: ['porter'] },
    archerCrypt: { label: 'Bone Archer Crypt', kind: 'crypt', units: ['archer'] },
    bruteCrypt: { label: 'Brute Crypt', kind: 'crypt', units: ['brute'] },
    lichAltar: { label: 'Lich Altar', kind: 'crypt', units: ['lich'] }
}

export const BUILD_SITES = [
    { id: 'guardCrypt', buildingType: 'guardCrypt', unlockWave: 0, x: 0, y: 0, recipe: { bones: 8, deadwood: 4 } },
    { id: 'graveForge', buildingType: 'graveForge', unlockWave: 1, x: -3, y: 4, recipe: { bones: 8, deadwood: 4 } },
    { id: 'sealAltar', buildingType: 'sealAltar', unlockWave: 2, x: 1, y: 4, recipe: { bones: 6, graveIron: 6 } },
    { id: 'soulCrucible', buildingType: 'soulCrucible', unlockWave: 3, x: -3, y: -4, recipe: { bones: 10, deadwood: 4, graveSeal: 2 } },
    { id: 'bindingCircle', buildingType: 'bindingCircle', unlockWave: 4, x: 1, y: -4, recipe: { bones: 6, soulCrystal: 6, graveSeal: 4 } },
    { id: 'harvesterCrypt', buildingType: 'harvesterCrypt', unlockWave: 5, x: -5, y: 12, recipe: { graveIron: 8, graveSeal: 6, spiritBinding: 4 } },
    { id: 'porterCrypt', buildingType: 'porterCrypt', unlockWave: 6, x: 5, y: -12, recipe: { graveIron: 8, graveSeal: 6, spiritBinding: 6 } },
    { id: 'archerCrypt', buildingType: 'archerCrypt', unlockWave: 7, x: -4, y: -12, recipe: { bones: 8, soulCrystal: 4, spiritBinding: 4 } },
    { id: 'bruteCrypt', buildingType: 'bruteCrypt', unlockWave: 8, x: 4, y: 12, recipe: { bones: 8, graveIron: 6, graveSeal: 4 } },
    { id: 'lichAltar', buildingType: 'lichAltar', unlockWave: 9, x: 8, y: 0, recipe: { bones: 8, graveSeal: 4, spiritBinding: 8 } }
]

export const UNIT_TYPES = {
    guard: { label: 'Bone Guard', role: 'combat', recipe: { bones: 2, souls: 1 }, cap: 12, health: 95, damage: 16, range: 0.8, cooldown: 0.9, speed: 1.9 },
    miner: { label: 'Skeleton Miner', role: 'miner', recipe: { bones: 2, graveSeal: 1 }, cap: 10, speed: 2.35 },
    woodcutter: { label: 'Skeleton Woodcutter', role: 'woodcutter', recipe: { bones: 2, deadwood: 1, graveSeal: 1 }, cap: 6, speed: 2.35 },
    porter: { label: 'Skeleton Porter', role: 'porter', recipe: { bones: 2, graveSeal: 1, spiritBinding: 1 }, cap: 8, speed: 2.8 },
    archer: { label: 'Bone Archer', role: 'combat', recipe: { bones: 2, deadwood: 2, soulCrystal: 1 }, cap: 10, health: 68, damage: 19, range: 5.5, cooldown: 1.3, speed: 1.75 },
    brute: { label: 'Skeleton Brute', role: 'combat', recipe: { bones: 4, graveIron: 2, graveSeal: 1 }, cap: 6, health: 280, damage: 28, range: 1.15, cooldown: 1.8, speed: 1.1, area: 2.2, taunt: 3.2 },
    lich: { label: 'Skeleton Lich', role: 'combat', recipe: { bones: 4, graveSeal: 1, spiritBinding: 2, souls: 3 }, cap: 3, health: 110, damage: 25, range: 6, cooldown: 1.8, speed: 1.5, healing: 20 }
}

export const ENEMY_TYPES = {
    hollow: { label: 'Hollow', health: 38, damage: 7, range: 0.75, cooldown: 1.05, speed: 1.25, cost: 1 },
    wraith: { label: 'Wraith', health: 32, damage: 7, range: 4.2, cooldown: 1.55, speed: 1.05, cost: 2 },
    inquisitor: { label: 'Inquisitor', health: 240, damage: 17, range: 1, cooldown: 1.45, speed: 0.78, cost: 8 }
}

export const WAVE_DEFINITIONS = [
    null,
    { hollow: 4 },
    { hollow: 6 },
    { hollow: 7, wraith: 1 },
    { hollow: 8, wraith: 2 },
    { hollow: 8, wraith: 2, inquisitor: 1 },
    { hollow: 10, wraith: 3 },
    { hollow: 12, wraith: 4 },
    { hollow: 12, wraith: 4, inquisitor: 1 },
    { hollow: 14, wraith: 5, inquisitor: 1 }
]

export const OSSUARY = { id: 'ossuary', x: 10.255, y: -13.4 }
export const ARENA = { portal: { x: 0, y: -28 }, obelisk: { x: 0, y: -14.5 }, center: { x: 0, y: -21 } }
